if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('.product-media-modal__navigation-button').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', this.onNavigationClick.bind(this));
        });
      }

      onNavigationClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        if (mediaItems.length < 2) return;

        const activeIndex = Math.max(
          0,
          mediaItems.findIndex((item) => item.classList.contains('active'))
        );
        const direction = event.currentTarget.name === 'next' ? 1 : -1;
        const nextIndex = (activeIndex + direction + mediaItems.length) % mediaItems.length;

        mediaItems.forEach((item) => item.classList.remove('active'));
        mediaItems[nextIndex].classList.add('active');
        mediaItems[nextIndex].scrollIntoView({ block: 'center', inline: 'center' });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
